import { useRef } from 'react'

import { FormControlLabel, Switch, withStyles } from '@material-ui/core'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { titles2 } from 'Helpers'
import ReactImageGallery from 'react-image-gallery'

import useStyles from '../styles'

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 60,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible',
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(34px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#3E984C',
        opacity: 1,
        border: 'none',
        '&:after': {
          color: 'white',
          fontSize: '8px',
          left: '8px',
          position: 'absolute',
          top: '5px',
        },
      },
    },
  },
  thumb: {
    width: 22,
    height: 22,
    backgroundColor: 'white',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: '#f1f1f1',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
    position: 'relative',
    '&:after': {
      color: '#b7b7b7',
      fontSize: '8px',
      position: 'absolute',
      top: '5px',
      right: '8px',
    },
  },
  checked: {},
}))(Switch)

const VehicleInfo = ({
  item,
  fullImg,
  setFullImg,
  open,
  handleClose,
  valueFilter,
  setValueFilter,
}) => {
  const classes = useStyles()

  const handleChangeSwitch = (event) => {
    const isChecked = event.target.checked

    setValueFilter({
      ...valueFilter,
      photoType: isChecked ? 'ESTACION_CERO' : 'REVISION',
    })
  }

  const formFirstStep = (item, ref, setFullImg) => {
    const revisionData = item.fotografias.map((url) => {
      if (!url) return { original: '', fecha: '' }

      const fileName = url.substring(url.lastIndexOf('/') + 1)
      const fechaExtraida = fileName.split('.')[0]

      const urlLimpia = `${url.substring(0, url.lastIndexOf('/'))}${url.substring(url.lastIndexOf('.'))}`

      return {
        original: urlLimpia,
        fecha: fechaExtraida,
      }
    })

    return [
      {
        class: 'custom',
        sm: 12,
        xs: 12,
        component: (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
            }}
          >
            <FormControlLabel
              control={
                <IOSSwitch
                  checked={valueFilter.photoType === 'ESTACION_CERO'}
                  onChange={handleChangeSwitch}
                  name="photoType"
                />
              }
              label={
                <span
                  style={{
                    fontSize: '13px',
                    fontWeight: 600,
                    color: valueFilter.photoType === 'ESTACION_CERO' ? '#3E984C' : '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Fotos estación cero
                </span>
              }
              labelPlacement="start"
            />
          </div>
        ),
      },
      {
        class: 'custom',
        component: (
          <ReactImageGallery
            ref={ref}
            items={
              valueFilter.photoType === 'ESTACION_CERO'
                ? titles2([].concat(item.fotografias, item.iniciales.reverse()))
                : titles2(
                    [].concat(
                      revisionData.map((d) => d.original),
                      item.iniciales.reverse()
                    )
                  )
            }
            renderItem={(itemData) => {
              const fotoInfo = revisionData.find((d) => d.original === itemData.original)
              const isRevision = valueFilter.photoType === 'REVISION'

              return (
                <div style={{ position: 'relative' }}>
                  <img
                    src={itemData.original}
                    alt={itemData.originalAlt}
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />

                  <div
                    style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      backgroundColor: isRevision && fotoInfo?.fecha ? 'rgba(0, 0, 0, 0.6)' : '',
                      color: 'white',
                      padding: '6px 12px',
                      borderRadius: '4px',
                      pointerEvents: 'none',
                    }}
                  >
                    {isRevision && fotoInfo?.fecha && (
                      <div
                        style={{
                          fontSize: '14px',
                          borderTop: '1px solid rgba(255, 255, 255, 0.03)',
                          margin: '4px',
                          padding: '2px',
                        }}
                      >
                        {fotoInfo.fecha}
                      </div>
                    )}
                  </div>
                </div>
              )
            }}
            onScreenChange={(e) => setFullImg({ fullScreen: e })}
            onClick={() => ref.current.fullScreen()}
            useBrowserFullscreen={false}
            showBullets={true}
            showPlayButton={false}
            lazyLoad={true}
            showThumbnails={false}
            onErrorImageURL={process.env.PUBLIC_URL + '/Images/unavailable.jpg'}
          />
        ),
        xs: 12,
        sm: 12,
      },
      {
        class: 'textfield',
        name: 'comentario',
        label: 'Observación ECOSOFT',
        value: item.comentario_ecosoft,
        md: 12,
        sm: 12,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'chasis',
        label: 'Nº de chasis',
        value: item.chasis_nro,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'nromotor',
        label: 'Nº de motor',
        value: item.motor_nro,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'motor',
        label: 'Motor',
        value: item.motor_marca,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'combustible',
        label: 'Combustible',
        value: item.combustible,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'kms',
        label: 'Kilometros',
        value: item.kms,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'transmision',
        label: 'Transmisión',
        value: item.transmision,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'traccion',
        label: 'Tracción',
        value: item.traccion,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'puertas',
        label: 'Puertas',
        value: item.puertas,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'color',
        label: 'Color',
        value: item.color,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'titulo',
        label: 'Título',
        value: item.modelo_titulo,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'ingreso',
        label: 'Fecha ingreso',
        value: item.fecha_ingreso,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'baja',
        label: 'Ingreso baja',
        value: item.fecha_baja,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },
      {
        class: 'textfield',
        name: 'tramite',
        label: 'Fin trámite',
        value: item.fecha_tramite,
        md: 6,
        sm: 6,
        xs: 12,
        inputProps: { readOnly: true },
      },

      {
        class: 'custom',
        md: 6,
        sm: 6,
        xs: 12,
      },
    ]
  }

  const ref = useRef()

  return (
    <DialogComponent
      title={
        <div>
          {item.marca} {item.modelo_titulo}
        </div>
      }
      subtitle={
        <div className={classes.subtitle}>
          <div>
            <b> Nº V: </b>
            {item.nrodev} - <b> Dominio:</b> {item.dominio}
          </div>
          <div className={classes.estadoTramite}>{item.estado}</div>
        </div>
      }
      disableEscapeKeyDown={fullImg.fullScreen === true ? true : false}
      widthLarge="700px"
      open={open}
      handleclose={handleClose}
      handleclos
      tipo="slide"
      children={<InputsWithoutValidate fields={formFirstStep(item, ref, setFullImg)} spacing={2} />}
    />
  )
}

export default VehicleInfo
